import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbCheckbox as ClbCheckbox_ } from '@celebration/design-system/dist/lib/checkbox';
const events = {
    onClbChange: ClbCheckbox_.events
        .onClbChange,
};
export const ClbCheckbox = createComponent({
    tagName: ClbCheckbox_.tagName,
    elementClass: ClbCheckbox_,
    react: React,
    events: events,
});
//# sourceMappingURL=index.js.map